<template>
  <div class="mb-5 border-left border-right border-secondary">
    <div v-for="time in data"
         :key="time.id"
         :class="`${time.methods.length === 0 ? 'opacity-30' : ''}`">
      <div
        class=""
        v-for="method in time.methods"
        :key="method.id">
        <div class="border-top border-secondary float-none">
          <div
            class="text-uppercase bg-secondary text-white font-weight-bold float-left text-center py-3"
            style="width: 80px">
            {{ time.name }}
          </div>

          <div
            class="text-uppercase text-secondary font-weight-bold py-3 pl-3"
            style="margin-left: 80px;">
            {{ method.name }}
          </div>
        </div>

        <div class="">
          <ClientDrugScheduleItem
            v-for="prescription in method.prescriptions"
            :key="prescription.id"
            :prescription="prescription"
            :date="date" />
        </div>
      </div>

      <div v-if="time.methods.length === 0">
        <div class="border-bottom border-top border-secondary float-none">
          <div
            class="text-uppercase bg-secondary text-white font-weight-bold float-left text-center py-3"
            style="width: 80px">
            {{ time.name }}
          </div>

          <div
            class="text-uppercase text-secondary font-weight-bold py-3 pl-3"
            style="margin-left: 80px;">
            Назначений на это время нет
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientDrugScheduleItem from './Item';

export default {
  name: 'ClientDrugScheduleList',

  props: ['prescriptions', 'date', 'times'],

  components: {ClientDrugScheduleItem},

  data() {
    return {};
  },

  computed: {
    data() {
      const times = this.times.map(({id, name, sort}) => {
        return {id, name, sort, methods: []};
      });

      this.prescriptions.forEach(prescription => {
        prescription.times.forEach(prescriptionTime => {
          const time = times.find(time => time.id === prescriptionTime.id);

          if (typeof time === 'undefined') {
            return;
          }

          prescription.methods.forEach(prescriptionMethod => {
            const method = time.methods.find(
              method => method.id === prescriptionMethod.id
            );

            if (typeof method !== 'undefined') {
              return method.prescriptions.push(prescription);
            }

            time.methods.push({
              id: prescriptionMethod.id,
              name: prescriptionMethod.name,
              sort: prescriptionMethod.sort,
              prescriptions: [prescription],
            });
          });
        });
      });

      times.sort((a, b) => a.sort - b.sort);
      times.forEach(time => time.methods.sort((a, b) => a.sort - b.sort));

      return times;
    }
  },
};
</script>
